import { render, staticRenderFns } from "./TextParser.vue?vue&type=template&id=3774bd41&"
import script from "./TextParser.vue?vue&type=script&lang=js&"
export * from "./TextParser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports